import { render } from "./PostsView.vue?vue&type=template&id=372e9117"
import script from "./PostsView.vue?vue&type=script&lang=js"
export * from "./PostsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__